import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'antd/dist/antd.css';
import {
  getIssues,
  getProject,
  getAssisantSkills,
  getJiraBoards,
  updateCommandapi,
  getFilterFromJira,
} from '../skills_action';

import axios from 'axios';
import { InfoCircleOutlined } from '@ant-design/icons';
import JiraIssueFields from '../jira/jiraIssueFields';
import JiraCommonIssueFields from '../jira/jiraCommonIssueFields';
import queryString from 'query-string';

import {
  Avatar,
  Button,
  Dropdown,
  Layout,
  Menu,
  PageHeader,
  Row,
  Col,
  Card,
  Statistic,
  Tooltip,
  Table,
  Modal,
  Input,
  Radio,
  Typography,
  Divider,
  Select,
  Switch,
  Checkbox,
  Popconfirm,
  Alert,
  Spin,
} from 'antd';

const { Header, Footer, Sider, Content } = Layout;
const { Text, Title } = Typography;
const { Option } = Select;

let initialState = {
  isCreating: false,
  commandType: '',
  creationDefaultIssueType: null,
  creationDefaultProject: null,
  listFilterType: 'pre-built',
  isCustomFilterModalVisible: false,
  commandKeyword: '',
  projectLoading: false,
  linkedProject: null,
  linkedProjectName: null,
  issueTypes: [],
  linkedIssue: null,
  purpose: '',
  isActive: false,
  isUpdating: false,
  key: '',
  showUpdateFieldModal: false,
  fieldDefaults: {},
  filters: {},
  selectedCommand: {},
  creationDefaults: {},
  commandError: false,
  purposeError: false,
  projectError: false,
  issuetypeError: false,
  commandTypeError: false,
  apiloading: false,
  selectedPreBuiltFilter: 'my-open',
  JQLfilter: null,
  orderBy: 'created',
  isAscendingOrder: 'false',
  jqlValidated: true,
  timeout: 0,
  selectedFilterFromJira: null,
  filterSelectVisible: true,
  filterFromJiraError: false,
};

class Commands extends React.Component {
  constructor(props) {
    super(props);
    this.handleJql = this.handleJql.bind(this);

    this.state = {
      ...initialState,
      dataSource: [],
      projects: [],
      filterFromJira: [],
    };
  }
  componentDidMount() {
    this.getCommands();
    this.props.getProject(this.props.match.params.wId).then((res) => {
      this.setState({ projects: res.data.projects });
    });
    getFilterFromJira(this.props.match.params.wId).then((res) => {
      this.setState({
        filterFromJira: res.data.items,
      });
    });
  }

  getSystemCommands = () => {
    const { skills } = this.props;
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    const wikiSkill = skills.find((skill) => skill.key === 'wiki');
    const helpdeskSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_service_desk'
      );
    return [
      // workspace_id: this.props.match.params.wId, // troopr workspace unique id to find a workspace
      //             keyphrase: this.state.commandKeyword,
      //             purpose: this.state.purpose,
      //             type: this.state.commandType,
      //             creationDefaults: {
      //                 project: selectedProjectData,
      //                 issueType: selectedIssueTypeData,
      //                 fieldDefaults: this.state.creationDefaults.fieldDefaults
      //             },
      //             isActive: true,
      //             team_id:this.props.team.id
      {
        _id: '62ebbf987f56f705a',
        key: '1',
        keyphrase: 'create',
        object: 'issue',
        type: 'create',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'create a new issue',
      },
      ...(helpdeskSubSkill
        ? [
            {
              _id: '',
              key: '2',
              keyphrase: 'request',
              object: 'troopr',
              type: 'request',
              isActive: true,
              isShared: true,
              created_by: 'Troopr',
              purpose: 'open request creation modal',
            },
          ]
        : []),
      {
        _id: '62ebbf987f56f785a',
        key: '3',
        keyphrase: 'list',
        object: 'issue',
        type: 'list',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'show list of issues',
      },
      {
        _id: '62ebbf987g56f705a',
        key: '4',
        keyphrase: 'find',
        object: 'issue',
        type: 'find',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'search for issues matching key phrase',
      },
      {
        _id: '62ebbf927f56f705a',
        key: '5',
        keyphrase: 'update',
        object: 'issue',
        type: 'update',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'update any issue field',
      },
      {
        _id: '62ebbfd87f56f705a',
        key: '6',
        keyphrase: 'status',
        object: 'issue',
        type: 'status',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'update status of a Jira issue',
      },
      {
        _id: '62ebbf987f56f70sa',
        key: '7',
        keyphrase: 'comment',
        object: 'issue',
        type: 'comment',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'add a comment to a Jira issue',
      },
      {
        _id: '62ebbs87f56f705a',
        key: '8',
        keyphrase: 'link',
        object: 'issue',
        type: 'link',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'link a Jira issue to another',
      },
      {
        _id: '62sbbf987f56f705a',
        key: '9',
        keyphrase: 'log',
        object: 'issue',
        type: 'log',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'log time against a Jira issue',
      },
      {
        _id: '62sbef987f56f705a',
        key: '10',
        keyphrase: 'sprint',
        object: 'issue',
        type: 'start',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'start or stop a sprint',
      },
      {
        _id: '62sbbf937f56f705a',
        key: '11',
        keyphrase: 'report',
        object: 'report',
        type: 'list',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'list my Troopr reports',
      },
      {
        _id: '62sbbf987f56f70qa',
        key: '12',
        keyphrase: 'configure',
        object: 'troopr',
        type: 'configure',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'open Troopr configuration options',
      },
      {
        _id: '62sbbh987f56f705a',
        key: '13',
        keyphrase: 'checkin',
        object: 'checkin',
        type: 'list',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'show list of my Check-ins',
      },
      ...(wikiSkill && wikiSkill.skill_metadata
        ? [
            {
              _id: '62sbbf987ft6f705a',
              key: '14',
              keyphrase: 'wiki',
              object: 'wiki',
              type: 'find',
              isActive: true,
              isShared: true,
              created_by: 'Troopr',
              purpose: 'search for Confluence articles matching key phrase',
            },
          ]
        : []),
      {
        _id: '62sbbf987f54f705a',
        key: '15',
        keyphrase: '',
        object: 'troopr',
        type: 'launcher',
        isActive: true,
        isShared: true,
        created_by: 'Troopr',
        purpose: 'open Troopr launcher',
      },
    ];
  };

  getCommands = async () => {
    // let getCommands = await axios.get(`/bot/api/${this.props.match.params.wId}/commands`).then(res => res)
    let getCommands = await axios
      .get(`/bot/api/w/${this.props.match.params.wId}/workspace/commands`)
      .then((res) => res);
    let data = getCommands.data.allCommands.map((object) => {
      return {
        ...object,
        key: object._id.toString(),
      };
    });
    this.setState({ dataSource: [...data, ...this.getSystemCommands()] });
    // return data;
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.projects != this.props.projects ||
      prevState.isCreating != this.state.isCreating ||
      prevState.isUpdating != this.state.isUpdating
    ) {
    }
    // if(prevState.dataSource!=this.state.dataSource) {
    //     this.setState({ dataSource: this.state.dataSource})
    // }
    // if(prevState.creationDefaults!==this.state.creationDefaults) {
    //     this.setState({ creationDefaults: this.state.creationDefaults})
    // }
    // if(prevState.fieldDefaults!==this.state.fieldDefaults) this.setState({fieldDefaults:this.state.fieldDefaults})

    // console.log('feildsDefaults in state \n\n', this.state.fieldDefaults, this.state.creationDefaults.fieldDefaults)
    // console.log(prevState.selectedCommand==this.state.selectedCommand)
    let test = {
      prebuildFilter: this.state.selectedPreBuiltFilter,
      customFields: this.state.filters,
      JQLfilter: this.state.JQLfilter,
      orderBy: this.state.orderBy,
      isAscendingOrder: this.state.isAscendingOrder,
      issuetype: this.state.issueTypes,
      project: this.state.projects,
    };
    // console.log(this.state.issueTypes)
    // console.log(this.props)
  }

  oncommandKeywordChange = (e) => {
    let myString = e.target.value;
    if (
      /^[A-Za-z0-9.]+$/.test(myString) &&
      this.state.commandKeyword.length != 1
    ) {
      // console.log('test target value !=1'/* , /^[A-Za-z0-9.]+$/.test(myString) */)
      let commandKeyword = myString.replace(/ /g, '');
      this.setState({ commandKeyword, commandError: false });
    } else if (
      this.state.commandKeyword.length == 1 &&
      e.target.value.length > 1
    ) {
      // console.log('commandlength ==1 , target value > 1')
      if (/^[A-Za-z0-9.]+$/.test(myString)) {
        this.setState({ commandKeyword: e.target.value, commandError: false });
      }
    } else if (this.state.commandKeyword.length == 1 && e.target.value == '') {
      // console.log("commandlenght == 1", "target vlaue == ''")
      this.setState({ commandKeyword: e.target.value, commandError: false });
    }

    // console.log("-----------------\n")
  };

  onPurposeChange = (e) => {
    let purpose = e.target.value;
    this.setState({ purpose: purpose, purposeError: false });
  };

  onlistFilterTypeChange = ({ target: { value } }) => {
    this.setState({
      listFilterType: value,
    });
  };

  onCreationDefaultProjectChange = (creationDefaultProject) => {
    this.setState({
      creationDefaultProject,
    });
  };

  onCreationDefaultIssueTypeChange = (creationDefaultIssueType) => {
    this.setState({
      creationDefaultIssueType,
    });
  };
  createCommandwindow = () => {
    this.setState({
      isCreating: true,
      fieldDefaults: {},
      creationDefaults: {},
    });
  };
  createCommand = async (record) => {
    let error = false;
    try {
      let selectedProjectData =
        this.state.projects &&
        this.state.projects.find(
          (project) => project.id === this.state.linkedProject
        );
      let selectedIssueTypeData =
        this.state.issueTypes &&
        this.state.issueTypes.find(
          (project) => project.value === this.state.linkedIssue
        );

      // console.log(selectedProjectData, selectedIssueTypeData, this.state.issueTypes && this.state.issueTypes)
      let data = {
        workspace_id: this.props.match.params.wId, // troopr workspace unique id to find a workspace
        keyphrase: this.state.commandKeyword,
        purpose: this.state.purpose,
        type: this.state.commandType,
        creationDefaults: {
          project: selectedProjectData,
          issueType: selectedIssueTypeData,
          fieldDefaults: this.state.fieldDefaults,
        },
        isActive: true,
        team_id: this.props.team.id,
        filter: {
          prebuildFilter: this.state.selectedPreBuiltFilter,
          customFields: this.state.filters,
          JQLfilter: this.state.JQLfilter,
          orderBy: this.state.orderBy,
          isAscendingOrder: this.state.isAscendingOrder,
          filterCondition: this.state.listFilterType,
          selectedFilterFromJira: this.state.selectedFilterFromJira,
        },
      };
      // this.state.commandType === 'create' ?
      //     data.creationDefaults = {
      //         project: selectedProjectData,
      //         issueType: selectedIssueTypeData,
      //         fieldDefaults: this.state.fieldDefaults
      //     } :
      //     data.filter = {
      //         prebuildFilter: this.state.selectedPrebuiltFilter,
      //         customFilter: this.state.filters,
      //         JQLfilter: this.state.JQLfilter

      //     }
      const commandAlreadyUsed = this.state.dataSource.find(
        (command) =>
          command.keyphrase.trim() === this.state.commandKeyword.trim()
      );
      let commandUsed =
        commandAlreadyUsed &&
        commandAlreadyUsed.keyphrase.trim() ===
          this.state.commandKeyword.trim();
      //    console.log("create data ,", data)
      if (this.state.commandKeyword == '') {
        this.setState({ commandError: true });
        error = true;
      }
      if (this.state.purpose == '') {
        this.setState({ purposeError: true });
        error = true;
      }
      if (this.state.commandType == '') {
        this.setState({ commandTypeError: true });
        error = true;
      }
      if (
        this.state.commandType == 'create' &&
        this.state.linkedProject == null
      ) {
        this.setState({ projectError: true });
        error = true;
      }
      if (
        this.state.commandType == 'create' &&
        this.state.linkedIssue == null
      ) {
        this.setState({ issuetypeError: true });
        error = true;
      }
      if (commandUsed) {
        error = true;
        this.setState({ commandError: true });
      }
      if (
        this.state.listFilterType === 'jira' &&
        this.state.selectedFilterFromJira == null
      ) {
        error = true;
        this.setState({ filterFromJiraError: true });
      }
      if (
        this.state.jqlValidated === false &&
        (this.state.commandType == 'list' ||
          this.state.commandType == 'find') &&
        this.state.listFilterType === 'jql'
      ) {
        error = true;
      }
      if (!error) {
        this.setState({ apiloading: true });
        // await axios.post(`/bot/api/${this.props.match.params.wId}/commands`, data).then(res => {
        await axios
          .post(
            `/bot/api/w/${this.props.match.params.wId}/workspace/commands`,
            data
          )
          .then((res) => {
            this.setState(initialState);

            this.setState({ apiloading: false });
            this.getCommands();
          });
      }
    } catch (error) {
      // console.error('unable to create command', error);
    }
  };

  updateCommand = async (key, checked, record) => {
    // try
    // console.log(key, checked, record)
    let isSwitched = checked != undefined ? { checked } : undefined;
    let error = false;
    let selectedProjectData =
      this.state.projects &&
      this.state.projects.find(
        (project) => project.id === this.state.linkedProject
      );
    let selectedIssueTypeData =
      this.state.issueTypes &&
      this.state.issueTypes.find(
        (issue) =>
          issue.value === this.state.linkedIssue && this.state.linkedIssue
      );

    let data = {
      workspace_id: this.props.match.params.wId, // troopr workspace unique id to find a workspace
      keyphrase: this.state.commandKeyword,
      purpose: this.state.purpose,
      type: this.state.commandType,
      creationDefaults: {
        project: selectedProjectData,
        issueType: selectedIssueTypeData,
        fieldDefaults: this.state.fieldDefaults,
      },
      team_id: this.props.team.id,
      // isActive:true
      filter: {
        prebuildFilter: this.state.selectedPreBuiltFilter,
        customFields: this.state.filters,
        JQLfilter: this.state.JQLfilter,
        orderBy: this.state.orderBy,
        isAscendingOrder: this.state.isAscendingOrder,
        filterCondition: this.state.listFilterType,
        selectedFilterFromJira: this.state.selectedFilterFromJira,
      },
    };
    // console.log(selectedProjectData, selectedIssueTypeData, this.state.issueTypes && this.state.issueTypes, data)
    // console.log(data)
    const commandAlreadyUsed = this.state.dataSource.find((command) => {
      return (
        command.keyphrase.trim() === this.state.commandKeyword.trim() &&
        (this.state.selectedCommand
          ? command._id !== this.state.selectedCommand._id
          : true)
      );
    });

    let commandUsed =
      !isSwitched &&
      commandAlreadyUsed &&
      commandAlreadyUsed.keyphrase.trim() === this.state.commandKeyword.trim();
    if (!isSwitched) {
      if (this.state.commandKeyword == '') {
        this.setState({ commandError: true });
        error = true;
      }
      if (this.state.purpose == '') {
        this.setState({ purposeError: true });
        error = true;
      }
      if (this.state.commandType == '') {
        this.setState({ commandTypeError: true });
        error = true;
      }
      if (
        this.state.linkedProject == null &&
        this.state.commandType == 'create'
      ) {
        this.setState({ projectError: true });
        error = true;
      }
      if (
        this.state.linkedIssue == null &&
        this.state.commandType == 'create'
      ) {
        this.setState({ issuetypeError: true });
        error = true;
      }
      if (commandUsed) {
        error = true;
        this.setState({ commandError: true });
      }
      if (
        this.state.jqlValidated === false &&
        (this.state.commandType == 'list' ||
          this.state.commandType == 'find') &&
        this.state.listFilterType === 'jql'
      ) {
        error = true;
      }
      if (
        this.state.listFilterType === 'jira' &&
        this.state.selectedFilterFromJira == null
      ) {
        error = true;
        this.setState({ filterFromJiraError: true });
      }
    } else {
      // let updated = this.state.dataSource.map((command) => {
      //   // console.log(command._id, command.key, key);
      //   let uC = {...command}
      //   if (command.key && command.key.toString() === key) {
      //     uC.isActive = isSwitched && isSwitched.checked;
      //     uC.created_by = user;
      //     uC.key = key;
      //     console.log(uC)
      //     return uC;
      //   } else return uC;
      // });

      // this.setState({ dataSource: updated });

      record.isActive = isSwitched && isSwitched.checked;
      record.team_id = this.props.team.id;
      delete record.created_by;
      delete record.createdAt;
      delete record.updated_by;
      delete record.updatedAt;
      delete record.__v;
      delete record._id;
      delete record.key;
      data = record;
    }
    if (!error) {
      this.setState({ apiloading: true });
      // axios.put(`/bot/api/${this.props.match.params.wId}/commands/${key}`, data)
      // .this(res => {
      //     this.setState(initialState)
      //     this.getCommands()
      //     this.setState({ apiloading: false })
      //     console.log("UPDATING COMPLETED", res)
      // })
      // .catch(err=>console.log(err))
      // let user = record.created_by
      if (isSwitched) {
        let updated = this.state.dataSource.map((command) => {
          let uC = { ...command };
          if (command.key && command.key.toString() === key) {
            uC.isActive = isSwitched && isSwitched.checked;
            // uC.created_by = user;
            uC.key = key;
            return uC;
          } else return uC;
        });
        this.setState({ dataSource: updated });
      }
      let res = await updateCommandapi(this.props.match.params.wId, key, data);
      if (res) {
        let updated = this.state.dataSource.map((command) => {
          let c = { ...command };
          if (command._id === this.state.selectedCommand._id) {
            this.setState({ selectedCommand: { ...res, key: res._id } });
            return { ...res, key: res._id.toString() };
          } else return c;
        });
        !isSwitched && this.setState({ dataSource: updated });
        this.setState(initialState);
      }
    }
    // }catch (error) {
    //     console.error('Unable To Update Command', error)
    // }
  };

  checkIsJqlValid = async (jql) => {
    let body = {
      jql: jql,
    };
    return axios
      .post(
        //   "/bot/api/skill/" +
        //     this.props.match.params.wId +
        //     "/verifyJql/" +
        //     this.props.match.params.wId,
        `/bot/api/w/${this.props.match.params.wId}/jira/verifyJql`,
        body
      )
      .then((res) => res);
  };

  handleJql = (e) => {
    this.setState({ JQLfilter: e.target.value });
    if (this.state.timeout) clearTimeout(this.state.timeout);
    this.state.timeout = setTimeout(() => {
      this.checkIsJqlValid(e.target.value).then((res) => {
        if (res.data.success) {
          this.setState({ jqlValidated: true });
        } else {
          this.setState({ jqlValidated: false });
        }
      });
    }, 300);
  };

  onUpdateFields = () => {
    this.setState({ showUpdateFieldModal: true });
  };

  customizeCommand = async (e, record) => {
    // console.log(record)
    this.setState({ selectedCommand: record });

    let project = record.creationDefaults && record.creationDefaults.project;
    project &&
      this.props
        .getIssues(this.props.match.params.wId, project.id, false)
        .then((res) => {
          if (res.data.success) {
            this.setState({
              linkedIssue:
                record.creationDefaults &&
                record.creationDefaults.issueType &&
                record.creationDefaults.issueType.value,
              creationDefaultIssueType:
                record.creationDefaults &&
                record.creationDefaults.issueType &&
                record.creationDefaults.issueType.value,
              issueTypes: res.data.issueTypes,
            });
          }
        });
    this.setState({
      commandKeyword: record.keyphrase,
      purpose: record.purpose,
      commandType: record.type,
      isActive: record.isActive,
      linkedProject:
        record.creationDefaults &&
        record.creationDefaults.project &&
        record.creationDefaults.project.id,
      linkedProjectName:
        record.creationDefaults &&
        record.creationDefaults.project &&
        `${record.creationDefaults.project.name} (${record.creationDefaults.project.key})`,
      creationDefaultIssueType:
        record.creationDefaults && record.creationDefaults.issueType,
      linkedIssue:
        record.creationDefaults &&
        record.creationDefaults.issueType &&
        record.creationDefaults.issueType.value,
      key: record.key,
      creationDefaultProject:
        record.creationDefaults && record.creationDefaults.project,
      creationDefaults: record.creationDefaults ? record.creationDefaults : {},
      fieldDefaults:
        record.creationDefaults &&
        record.creationDefaults.fieldDefaults &&
        record.creationDefaults.fieldDefaults,

      selectedPreBuiltFilter: record.filter && record.filter.prebuildFilter,
      filters: record.filter && record.filter.customFields,
      JQLfilter: record.filter && record.filter.JQLfilter,
      orderBy: record.filter && record.filter.orderBy,
      isAscendingOrder: record.filter && record.filter.isAscendingOrder,
      listFilterType: record.filter && record.filter.filterCondition,
      selectedFilterFromJira:
        record.filter && record.filter.selectedFilterFromJira,
    });
    this.setState({ isUpdating: true });
    this.setState({ isCreating: true });
  };

  setCommandType = ({ target: { value } }) => {
    // console.log(value)
    this.setState({
      commandType: value,
      commandTypeError: false,
      listFilterType: 'pre-built',
      selectedPreBuiltFilter: 'my-open',
    });
  };
  onCheckBoxChange = (e) => {
    this.setState({ isShared: e.target.checked });
  };
  setIsCustomFilterModalVisible = (isCustomFilterModalVisible) => {
    this.setState({
      isCustomFilterModalVisible,
    });
  };

  showCustomFilterModal = () => {
    this.setIsCustomFilterModalVisible(true);
  };

  handleCustomFilterModalOk = () => {
    this.setIsCustomFilterModalVisible(false);
  };

  onChangeProject = (event) => {
    // const { channel_type } = this.state;
    let value =
      this.props.projects &&
      this.props.projects.find((project) => project.id === event);
    /* this.state.creationDefaults!={} && */ this.setState(
      {
        linkedProject: event,
        linkedProjectName: `${value.name} (${value.key})`,
        creationDefaultProject: value,
        creationDefaults: { ...this.state.creationDefaults, project: value },
        projectError: false,
      },
      () => {
        let query = 'projectKeyOrId=' + this.state.linkedProject;
      }
    );
    this.props
      .getIssues(this.props.match.params.wId, value.id, false)
      .then((res) => {
        if (res.data.success) {
          this.setState({
            linkedIssue: res.data.issueTypes[0].value,
            creationDefaultIssueType: res.data.issueTypes[0],
            issueTypes: res.data.issueTypes,
            creationDefaults: {
              ...this.state.creationDefaults,
              issueType: res.data.issueTypes[0],
            },
            issuetypeError: false,
          });
        } else {
          this.setState(() => ({ linkedIssue: null }));
        }
      });
  };

  onChangeIssue = (event) => {
    // console.log(event)
    let selectedIssueTypeData =
      this.state.issueTypes &&
      this.state.issueTypes.find((project) => project.value === event);
    // console.log(selectedIssueTypeData)
    this.setState({
      linkedIssue: event,
      creationDefaultIssueType: selectedIssueTypeData,
      creationDefaults: {
        ...this.state.creationDefaults,
        issueType: selectedIssueTypeData,
      },
    });
  };

  handleCustomFilterModalOk = () => {
    this.setState({ showUpdateFieldModal: false });
    // this.setState({fieldDefaults:selectedActionForUpadate ? (selectedActionForUpadate.arguments && selectedActionForUpadate.arguments.fieldDefaults) || {} : {}});
  };

  deleteCommand = async (record) => {
    //  let link = `/bot/api/${this.props.match.params.wId}/commands/${record.key}`
    let link = `/bot/api/w/${this.props.match.params.wId}/workspace/commands/${record.key}`;
    await axios.delete(link).then((res) => {
      if (res.data.success) {
        let updatedCommands = [];
        this.state.dataSource.forEach((command) => {
          if (command._id !== record._id) updatedCommands.push(command);
        });
        this.setState({ dataSource: updatedCommands });
      }
    });
  };
  handleDisableSwitch = async (checked, record) => {
    this.updateCommand(record._id, checked, record);
  };

  render() {
    const { user_now } = this.props;

    const columns = [
      {
        title: 'Command',
        dataIndex: 'keyphrase',
        key: 'keyphrase',
        width: 200,
        render: (text, record) => (
          <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
            {`/t ${text}`}
          </div>
        ),
      },
      {
        title: 'Purpose',
        dataIndex: 'purpose',
        key: 'purpose',
        width: 300,
        render: (text, record, index) => (
          <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
            {text}
          </div>
        ),
      },
      {
        title: 'Status',
        width: 100,
        key: 'q',
        render: (record, data) => {
          if (record.created_by && record.created_by != 'Troopr') {
            return (
              <Switch
                checked={record.isActive}
                disabled={
                  !(
                    (user_now && record.created_by.user_id === user_now._id) ||
                    this.props.isWorkspaceAdimin
                  )
                }
                onChange={(checked) =>
                  this.handleDisableSwitch(checked, { ...record })
                }
                style={{ marginRight: 8 }}
              />
            );
          }
        },
      },
      //   {
      //       title: 'Scope',
      //       width: 200,
      //       dataIndex: 'isShared',
      //       key: 'isShared',
      //       render: (text) => <div>{text ? 'Shared with team' : 'Personal'}</div>,
      //   },
      {
        title: 'Creator',
        dataIndex: 'created_by',
        key: 'createdBy',
        width: 200,
        render: (text, record, index) => {
          // console.log("here", text, record)

          return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
              {record.created_by
                ? record.created_by.displayName ||
                  record.created_by.name ||
                  record.created_by.user_name
                : 'Not a member'}
            </div>
          );
        },
      },
      {
        key: 'w',
        render: (text, record, index) =>
          record.created_by != 'Troopr' &&
          ((user_now &&
            (record.created_by && record.created_by.user_id) ===
              user_now._id) ||
            this.props.isWorkspaceAdimin) && (
            <div
              style={{
                visibility:
                  record.created_by === 'Troopr' ? 'hidden' : 'visible',
              }}
            >
              <Button
                onClick={(e) => {
                  this.customizeCommand(e, record);
                  this.setState({ key: record._id });
                }}
              >
                Customize
              </Button>
              <Popconfirm
                title='Are you sure want to delete this command ?'
                onConfirm={() => this.deleteCommand(record)}
              >
                <Button type='link'>
                  <Text type='danger'>Delete</Text>
                </Button>
              </Popconfirm>
            </div>
          ),
      },
    ];
    // console.log("data source ", this.state.dataSource)

    const jiraSkill = this.props.skills.find((skill) => skill.key === 'jira');
    const isJiraProductsEnabled =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find((ss) => !ss.disabled);
    const jiraSkill_linked =
      jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.linked;
    const isAdmin = this.props.isWorkspaceAdimin;
    const commandError = this.state.commandError;

    const purposeError = this.state.purposeError;
    const projectError = this.state.projectError;
    const issuetypeError = this.state.issuetypeError;
    const commandTypeError = this.state.commandTypeError;
    const key = this.state.key;

    let servertype =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      jiraSkill.skill_metadata.metadata.server_type;

    const helpdeskSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_service_desk'
      );

    const filteredProjects = !helpdeskSubSkill
      ? this.props.projects &&
        this.props.projects.filter(
          (project) => project.projectTypeKey !== 'service_desk'
        )
      : this.props.projects;

    //   if (servertype && servertype === "jira_server_oauth") {
    //       this.setState({filterSelectVisible:false})
    //     }
    // console.log(this.state.filterFromJiraError)

    // console.log(this.state.fieldDefaults, this.state.JQLfilter, this.state.selectedPreBuiltFilter)
    return (
      <>
        <Modal
          title='Custom Filter'
          visible={this.state.isCustomFilterModalVisible}
          onOk={() => this.setState({ isCustomFilterModalVisible: false })}
          onCancel={() => this.setState({ isCustomFilterModalVisible: false })}
          width={600}
        >
          <JiraCommonIssueFields
            skill_id={jiraSkill && jiraSkill.skill_metadata._id}
            handleUpdateFieldDefaultsChanges={(data) => {
              this.setState({ filters: data });
            }}
            forCommands={true}
            selectedCommand={this.state.selectedCommand}
          />
        </Modal>
        <Modal
          title='Update fields'
          visible={this.state.showUpdateFieldModal}
          onOk={() => this.setState({ showUpdateFieldModal: false })}
          onCancel={() => this.setState({ showUpdateFieldModal: false })}
          maskClosable={false}
          // destroyOnClose={true}
          centered
          bodyStyle={{
            maxHeight: '70vh',
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <JiraIssueFields
            issues={this.state.issueTypes}
            linkedIssue={this.state.linkedIssue}
            // linkedIssue={this.state.creationDefaultIssueType ? this.state.creationDefaultIssueType.value : null}
            linkedProject={
              this.state.creationDefaultProject
                ? this.state.creationDefaultProject.id
                : null
            }
            handleFieldDefaultsChange={(fieldDefaults) => {
              /* console.log('handlefuntion fielddefault in commands\n', fieldDefaults, {...fieldDefaults[this.state.creationDefaultIssueType.value]}) */ this.setState(
                { fieldDefaults: { ...fieldDefaults[this.state.linkedIssue] } }
              );
            }}
            selectedCommandForUpdate={
              this.state.selectedCommand.creationDefaults
            }
            forCommands={true}
            skill_id={jiraSkill && jiraSkill.skill_metadata._id}
            // fdefaults={this.state.fieldDefaults}
          />
        </Modal>
        <PageHeader
          // className="site-page-header"
          // onBack={() => null}
          title='Troopr Commands'
          subTitle='Slash command (/t) that you can use to invoke Troopr from anywhere in Slack'
        />
        <Content
          className='site-layout-background'
          style={{ padding: 32, overflow: 'scroll', height: '14vh' }}
        >
          {jiraSkill ? (
            <>
              {isJiraProductsEnabled ? (
                jiraSkill_linked ? (
                  <>
                    {!isAdmin && (
                      <Alert
                        message='Only workspace admins can create or update commands'
                        type='warning'
                        style={{ marginBottom: 16 }}
                      />
                    )}

                    {this.state.isCreating || this.state.isUpdating ? (
                      <>
                        <Card
                          style={{ overflow: 'scroll', height: 'fit-content' }}
                          title={
                            <>
                              <Button
                                onClick={() => {
                                  this.setState(initialState);
                                  this.getCommands();
                                }}
                                style={{ marginRight: 8 }}
                              >
                                Back
                              </Button>
                              <Text strong>
                                {this.state.isUpdating
                                  ? 'Edit command'
                                  : 'Creating new command'}
                              </Text>
                            </>
                          }
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexFlow: 'column',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: '1 1 auto',
                                // marginTop: 32,
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: 8,
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                }}
                              >
                                <div style={{ width: 200 }}>
                                  <div
                                    style={{ float: 'right', marginRight: 8 }}
                                  >
                                    <Text strong>
                                      Command keyword{' '}
                                      <a
                                        onClick={() =>
                                          Modal.info({
                                            title: 'Command keyword',
                                            content: (
                                              <div>
                                                <Text>
                                                  Use a unique command to
                                                  identify the Troopr action you
                                                  want to perform. Command
                                                  keyword is case insensitive
                                                  and 1 to 16 characters long.
                                                  Allowed characters are letters
                                                  (a-z), numbers (0-9), and
                                                  periods (.)
                                                </Text>
                                              </div>
                                            ),
                                            onOk() {},
                                          })
                                        }
                                      >
                                        <InfoCircleOutlined />
                                      </a>
                                    </Text>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // alignItems: 'center',
                                  }}
                                >
                                  <Input
                                    value={this.state.commandKeyword}
                                    maxLength={16}
                                    onChange={this.oncommandKeywordChange}
                                    placeholder='example: cre'
                                    style={{ maxWidth: 300, marginRight: 16 }}
                                    // pattern="[a-zA-Z0-9.]"
                                  />
                                  {/* <Checkbox name="isShared" value={this.state.isShared} onChange={(e)=>this.onCheckBoxChange(e)} style={{ width: 300 }}>
                          share with team{' '}
                          <Tooltip title="prompt text"></Tooltip>
                        </Checkbox> */}
                                  {commandError && (
                                    <Text
                                      type='danger' /* style={{ marginLeft: "200px", marginTop: "-16px" }} */
                                    >
                                      * Command already in use, please choose
                                      another command
                                    </Text>
                                  )}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  marginBottom: 8,
                                  alignItems: 'center',
                                }}
                              >
                                <div style={{ width: 200 }}>
                                  <div
                                    style={{ float: 'right', marginRight: 8 }}
                                  >
                                    <Text strong>Purpose:</Text>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <Input
                                    value={this.state.purpose}
                                    maxLength={128}
                                    placeholder='quickly create an issue in current sprint'
                                    onChange={(e) => this.onPurposeChange(e)}
                                    style={{ width: 500 }}
                                  />
                                  {purposeError && (
                                    <Text type='danger'>
                                      * Please enter purpose
                                    </Text>
                                  )}
                                </div>
                              </div>
                              {true && (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                  }}
                                >
                                  <div style={{ width: 200 }}>
                                    <div
                                      style={{ float: 'right', marginRight: 8 }}
                                    >
                                      <Text strong>Command type:</Text>
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <div style={{ marginBottom: 4 }}>
                                      <Radio.Group
                                        options={[
                                          {
                                            label: 'Issue create',
                                            value: 'create',
                                          },
                                          {
                                            label: 'Issue list',
                                            value: 'list',
                                          },
                                          {
                                            label: 'Issue find',
                                            value: 'find',
                                          },
                                        ]}
                                        value={this.state.commandType}
                                        onChange={this.setCommandType}
                                      />
                                      {commandTypeError && (
                                        <Text type='danger'>
                                          * Please select command type
                                        </Text>
                                      )}
                                    </div>
                                    {this.state.commandKeyword &&
                                    this.state.commandType === 'create' ? (
                                      <>
                                        <div>
                                          <Text code style={{ marginRight: 4 }}>
                                            /t {this.state.commandKeyword}{' '}
                                            issue-summary
                                          </Text>
                                          <Text type='secondary'>
                                            create Jira issue
                                          </Text>
                                        </div>
                                      </>
                                    ) : this.state.commandKeyword &&
                                      (this.state.commandType === 'list' ||
                                        this.state.commandType === 'find') ? (
                                      <>
                                        <div>
                                          <Text code style={{ marginRight: 4 }}>
                                            {this.state.commandType === 'list'
                                              ? `/t ${this.state.commandKeyword}`
                                              : `/t ${this.state.commandKeyword} search-keyword`}
                                          </Text>
                                          <Text type='secondary'>
                                            {this.state.commandType === 'list'
                                              ? 'Show list of Jira issues'
                                              : 'find Jira issues containing search-keyword'}
                                          </Text>
                                        </div>
                                      </>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>
                              )}

                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                              >
                                {this.state.commandType === 'create' ? (
                                  <>
                                    <Divider />
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div style={{ width: 200 }}>
                                        <div
                                          style={{
                                            float: 'right',
                                            marginRight: 8,
                                          }}
                                        >
                                          <Text strong>Creation Defaults:</Text>
                                        </div>
                                      </div>
                                      {/* <div style={{ display: 'flex', flexDirection: 'column' }}> */}
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Select
                                          name='linkedProject'
                                          style={{ width: 150, marginRight: 8 }}
                                          placeholder='Select Project'
                                          value={this.state.linkedProjectName}
                                          onChange={(e) =>
                                            this.onChangeProject(
                                              e,
                                              this.state.creationDefaults
                                                .project
                                            )
                                          }
                                          showSearch={true}
                                          filterOption={(input, option) =>
                                            option.props.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                          loading={this.state.projectLoading}
                                        >
                                          {filteredProjects &&
                                            filteredProjects.map(
                                              (project, index) => {
                                                return (
                                                  <Option
                                                    key={project.id}
                                                    value={project.id}
                                                  >
                                                    {project.name +
                                                      ` (${project.key})`}
                                                  </Option>
                                                );
                                              }
                                            )}
                                        </Select>
                                        <Select
                                          // disabled={!this.state.linkedProject || !this.state.edit}
                                          name='linkedIssue'
                                          placeholder='Select IssueType'
                                          style={{ width: 150, marginRight: 8 }}
                                          value={this.state.linkedIssue}
                                          onChange={this.onChangeIssue}
                                          // disabled={projectFound ? false : true}
                                          //   disabled={projectFound ? currentChannelConfigs != false && !isChannelAdmin && !isWorkspaceAdimin : true}
                                          showSearch={true}
                                        >
                                          {
                                            /* (showRequestTypeFromRestriction
                                        ? channelCommonData.requestTypeRestriction.find(
                                            (restriction) => restriction.project.projectId === this.state.linkedProject
                                          ).requestTypes
                                        : this.props.issues && this.props.issues
                                      ) */

                                            this.props.issues &&
                                              this.props.issues.map(
                                                (issue, index) => (
                                                  <Option
                                                    key={issue.value}
                                                    value={issue.value}
                                                  >
                                                    {issue.text}
                                                  </Option>
                                                )
                                              )
                                          }
                                        </Select>
                                      </div>
                                      {this.state.creationDefaultProject &&
                                        this.state.creationDefaultIssueType && (
                                          <div>
                                            <div>
                                              <Text style={{ marginRight: 4 }}>
                                                {this.state.fieldDefaults &&
                                                Object.keys(
                                                  this.state.fieldDefaults
                                                ).length > 0
                                                  ? `${
                                                      Object.keys(
                                                        this.state.fieldDefaults
                                                      ).length
                                                    } field value(s) set`
                                                  : 'No field values set'}
                                              </Text>
                                              <a
                                                onClick={() =>
                                                  this.onUpdateFields()
                                                }
                                              >
                                                Update
                                              </a>
                                              <Text> | </Text>
                                              <a
                                                onClick={() => {
                                                  this.setState({
                                                    creationDefaultProject:
                                                      null,
                                                    creationDefaultIssueType:
                                                      null,
                                                    linkedIssue: null,
                                                    linkedProject: null,
                                                    linkedProjectName: null,
                                                    fieldDefaults: {},
                                                    creationDefaults: {},
                                                  });
                                                }}
                                              >
                                                Clear
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                    {projectError && (
                                      <Text
                                        type='danger'
                                        style={{ marginLeft: '200px' }}
                                      >
                                        * Please select project
                                      </Text>
                                    )}
                                    {issuetypeError && (
                                      <Text
                                        type='danger'
                                        style={{
                                          marginLeft: '360px',
                                          marginTop: projectError
                                            ? '-22px'
                                            : '',
                                        }}
                                      >
                                        * Please select issuetype
                                      </Text>
                                    )}
                                    {/* </div> */}
                                  </>
                                ) : this.state.commandType === 'list' ||
                                  this.state.commandType === 'find' ? (
                                  <>
                                    <Divider />
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        // marginBottom: 16,
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div style={{ width: 200 }}>
                                        <div
                                          style={{
                                            float: 'right',
                                            marginRight: 8,
                                          }}
                                        >
                                          <Text strong>Filter condition:</Text>
                                        </div>
                                      </div>

                                      <div>
                                        {/* <Text style={{ marginRight: 8 }}>
                              Choose filter type
                            </Text> */}
                                        <Radio.Group
                                          value={this.state.listFilterType}
                                          onChange={this.onlistFilterTypeChange}
                                          defaultValue='pre-built'
                                          // optionType="button"
                                          // buttonStyle="solid"
                                        >
                                          <Radio value='pre-built'>
                                            Pre-built filter
                                          </Radio>
                                          <Radio value='custom'>
                                            Custom filter
                                          </Radio>
                                          <Radio value='jql'>JQL filter</Radio>
                                          {servertype &&
                                            servertype ===
                                              'jira_cloud_oauth' && (
                                              <Radio value='jira'>
                                                Filter from Jira
                                              </Radio>
                                            )}
                                        </Radio.Group>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        // flexWrap: 'wrap',
                                        marginTop: 8,
                                      }}
                                    >
                                      <div style={{ width: 200 }} />
                                      {this.state.listFilterType === 'jira' ? (
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                          }}
                                        >
                                          <Select
                                            style={{ width: 220 }}
                                            showSearch
                                            allowClear
                                            placeholder='Choose filter'
                                            value={
                                              this.state.selectedFilterFromJira
                                                ? this.state
                                                    .selectedFilterFromJira
                                                : null
                                            }
                                            onChange={(value, data) =>
                                              this.setState({
                                                selectedFilterFromJira: value,
                                                filterFromJiraError: false,
                                              })
                                            }
                                          >
                                            {this.state.filterFromJira &&
                                              this.state.filterFromJira.map(
                                                (filter) => {
                                                  return (
                                                    <Option
                                                      key={filter.id}
                                                      value={filter.jql}
                                                      data={filter}
                                                    >
                                                      {filter.name}
                                                    </Option>
                                                  );
                                                }
                                              )}
                                          </Select>
                                          {this.state.filterFromJiraError && (
                                            <Text
                                              type='danger' /* style={{ marginLeft: "360px", marginTop: projectError ? "-22px" : "" }} */
                                            >
                                              * Please select filter
                                            </Text>
                                          )}
                                        </div>
                                      ) : this.state.listFilterType ===
                                        'pre-built' ? (
                                        <Select
                                          style={{ width: 220 }}
                                          value={
                                            this.state.selectedPreBuiltFilter
                                          }
                                          onChange={(value) =>
                                            this.setState({
                                              selectedPreBuiltFilter: value,
                                            })
                                          }
                                        >
                                          <Option value='my-open'>
                                            My open issues
                                          </Option>
                                          <Option value='assgined-to-me'>
                                            Assigned to me
                                          </Option>
                                          <Option value='viewed-recent'>
                                            Viewed recently
                                          </Option>
                                          <Option value='created-recent'>
                                            Created recently
                                          </Option>
                                          <Option value='resolved-recent'>
                                            Resolved recently
                                          </Option>
                                          <Option value='updated-recent'>
                                            Updated recently
                                          </Option>
                                          <Option value='done'>
                                            Done Issues
                                          </Option>
                                          <Option value='reported-by-me'>
                                            Reported by me
                                          </Option>
                                          <Option value='watched-by-me'>
                                            Watched by me
                                          </Option>
                                          <Option value='all-open'>
                                            All Open
                                          </Option>
                                          <Option value='all'>
                                            All Issues
                                          </Option>
                                        </Select>
                                      ) : this.state.listFilterType ===
                                        'custom' ? (
                                        <>
                                          <Text style={{ marginRight: 8 }}>
                                            {this.state.filters &&
                                            Object.values(
                                              this.state.filters
                                            ).filter(
                                              (value) =>
                                                value && value.length > 0
                                            ).length > 0
                                              ? `${
                                                  Object.values(
                                                    this.state.filters
                                                  ).filter(
                                                    (value) =>
                                                      value && value.length > 0
                                                  ).length
                                                } field value(s) set`
                                              : 'No field values set'}
                                          </Text>
                                          <a
                                            onClick={this.showCustomFilterModal}
                                          >
                                            Update Filter
                                          </a>
                                        </>
                                      ) : this.state.listFilterType ===
                                        'jql' ? (
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                          }}
                                        >
                                          <Input.TextArea
                                            style={{ width: 500 }}
                                            placeholder='write JQL query here'
                                            value={this.state.JQLfilter}
                                            onChange={(e) => {
                                              let timeout;
                                              this.handleJql(e, timeout);
                                            }}
                                          />
                                          {this.state.jqlValidated !== true && (
                                            <Text
                                              type='danger' /* style={{ marginLeft: "360px", marginTop: projectError ? "-22px" : "" }} */
                                            >
                                              please enter correct JQL
                                            </Text>
                                          )}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    {/* <Divider /> */}
                                    {this.state.listFilterType === 'custom' && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          marginTop: 16,
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div style={{ width: 200 }}>
                                          <div
                                            style={{
                                              float: 'right',
                                              marginRight: 8,
                                            }}
                                          >
                                            <Text strong>Order by:</Text>
                                          </div>
                                        </div>
                                        <Select
                                          style={{ width: 150, marginRight: 8 }}
                                          defaultValue={this.state.orderBy}
                                          onChange={(value) =>
                                            this.setState({ orderBy: value })
                                          }
                                        >
                                          <Option value='created'>
                                            Created
                                          </Option>
                                          <Option value='updated'>
                                            Updated
                                          </Option>
                                          <Option value='lastViewed'>
                                            Last viewed
                                          </Option>
                                          <Option value='priority'>
                                            Priority
                                          </Option>
                                          <Option value='key'>Issue key</Option>
                                        </Select>
                                        <Radio.Group
                                          value={this.state.isAscendingOrder}
                                          onChange={(e) =>
                                            this.setState({
                                              isAscendingOrder: e.target.value,
                                            })
                                          }
                                        >
                                          <Radio value='true'>Ascending</Radio>
                                          <Radio value='false'>
                                            Descending
                                          </Radio>
                                        </Radio.Group>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  ''
                                )}
                              </div>
                              <Divider />
                            </div>
                            <div style={{ display: 'flex', flex: '0 1 40px' }}>
                              <Button
                                style={{ marginLeft: '200px' }}
                                type='primary'
                                loading={this.state.apiloading}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.state.isUpdating
                                    ? this.updateCommand(key)
                                    : this.createCommand();
                                }}
                              >
                                {this.state.isUpdating
                                  ? 'Update command'
                                  : 'Create Command'}
                              </Button>
                            </div>
                          </div>
                        </Card>
                      </>
                    ) : (
                      <Card
                        title={
                          isAdmin ? (
                            <Button
                              type='primary'
                              onClick={this.createCommandwindow}
                            >
                              + New Command
                            </Button>
                          ) : (
                            ''
                          )
                        }
                        style={{
                          overflow: 'scroll',
                          height: 'fit-content',
                          minWidth: '900px',
                        }}
                      >
                        <Table
                          dataSource={this.state.dataSource}
                          columns={columns}
                          pagination={{ pageSize: 6 }}
                        />
                      </Card>
                    )}
                  </>
                ) : (
                  <Alert
                    message='You need an active Jira connection to create commands'
                    type='warning'
                    style={{ marginBottom: 16 }}
                  />
                )
              ) : (
                <Alert
                  message='You need Troopr Projects or Troopr HelpDesk or Troopr Reports enabled to use commands'
                  type='warning'
                  style={{ marginBottom: 16 }}
                />
              )}
            </>
          ) : (
            <Spin style={{ marginLeft: '50%', marginTop: '25%' }} />
          )}
        </Content>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projects: state.skills.projects,
    issues: state.skills.issues,
    user_now: state.common_reducer.user,

    isWorkspaceAdimin: state.common_reducer.isAdmin,
    skills: state.skills.skills,
    team: state.skills.team,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getIssues,
    getProject,
    getAssisantSkills,
    getJiraBoards,
  })(Commands)
);

// fields: []
// name
// value: []
// isActive: true,
// isShared: true,
// filter
// type: [preBuilt | custom | jql | jira]
// preBuiltFilter
// custom
// jql
// derivedJQL
// jiraFilter
// orderBy
// name
// direction: [asc | desc]
